<template>
  <div class="parking-management-bg">
    <!-- 主標題 -->
    <!-- 表單內容 -->
    <div v-if="!isSubmissionSuccess" class="form-content">
      <h2 class="page-title">委託與合作</h2>
      <p class="title-description">填寫以下表單，我們將儘快與您聯繫</p>
 
      <!-- <form @submit.prevent="submitForm"> -->
      <!-- 第一部分：停車場地委托經營資料 -->
      <div class="form-card">
        <h4 class="sub-title">停車場地委託經營資料</h4>
        <div class="two-columns">
          <!-- 停車場形式 -->
          <div class="form-group">
            <label for="parkingType">停車場形式</label>
            <select id="parkingType" v-model="formData.parking_type" class="form-select font-control">
              <option value="平面空地">平面空地</option>
              <option value="地下室平面">地下室平面</option>
              <option value="地下室平面 與 機械">地下室平面 與 機械</option>
              <option value="升降機式停車場">升降機式停車場</option>
              <option value="立體停車塔">立體停車塔</option>
              <option value="其他">其他</option>
            </select>
          </div>
          <!-- 車位數 -->
          <div class="form-group">
            <label for="parkingSpaces">車位數</label>
            <select id="parkingSpaces" v-model="formData.capacity" class="form-select font-control">
              <option value="50個以下">50個以下</option>
              <option value="50 ~ 99個">50 ~ 99個</option>
              <option value="100 ~ 299個">100 ~ 299個</option>
              <option value="300以上">300以上</option>
            </select>
          </div>
          <!-- 停車場現況 -->
          <div class="form-group">
            <label for="parkingStatus">停車場現況</label>
            <select id="parkingStatus" v-model="formData.parking_status" class="form-select font-control">
              <option value="自行經營">自行經營</option>
              <option value="現有委託經營廠商">現有委託經營廠商</option>
              <option value="新建停車場尚未營業">新建停車場尚未營業</option>
              <option value="目前為空地，正規劃為停車場">目前為空地，正規劃為停車場</option>
              <option value="其他">其他</option>
            </select>
          </div>
        </div>
        <!-- 停車場設備(可複選) -->
        <div class="form-group">
          <label>停車場設備(可複選)</label>
          <div class="equipment-buttons">
            <button v-for="item in equipmentOptions" :key="item.value"
              :class="['equipment-button', 'font-control', { active: formData.facilities.includes(item.value) }]"
              @click="toggleEquipment(item.value)" type="button">
              <span v-if="formData.facilities.includes(item.value)" class="checkmark">✓</span>
              {{ item.label }}
            </button>
          </div>
        </div>
        <div class="two-columns">
          <!-- 租期 -->
          <div class="form-group">
            <label for="rentalPeriod">租期</label>
            <select id="rentalPeriod" v-model="formData.contract_period" class="form-select font-control">
              <option value="短期六~十二個月內">短期六~十二個月內</option>
              <option value="一年~二年">一年~二年</option>
              <option value="三年以上">三年以上</option>
              <option value="長期合作">長期合作</option>
            </select>
          </div>
          <!-- 委託者身份 -->
          <div class="form-group">
            <label for="consignorIdentity">委託者身份</label>
            <select id="consignorIdentity" v-model="formData.lessee_type" class="form-select font-control">
              <option value="個人">個人</option>
              <option value="企業團體">企業團體</option>
              <option value="公家機關">公家機關</option>
              <option value="大樓(社區)管委會">大樓(社區)管委會</option>
            </select>
          </div>
          <!-- 同業/異業聯盟 -->
          <div class="form-group">
            <label for="organizationType">同業/異業聯盟</label>
            <select id="organizationType" v-model="formData.alliance" class="form-select font-control">
              <option value="同業聯盟">同業聯盟</option>
              <option value="餐飲業">餐飲業</option>
              <option value="廣告">廣告</option>
              <option value="旅遊業">旅遊業</option>
              <option value="場地租借">場地租借</option>
              <option value="停車特約">停車特約</option>
              <option value="其他">其他</option>
            </select>
          </div>
        </div>
      </div>

      <!-- 第二部分：停車場位置和聯絡人資料 -->
      <div class="form-card">
        <h4 class="sub-title">停車場聯絡人資料</h4>
        <div class="two-columns">
          <!-- 客戶名稱 -->
          <div class="form-group">
            <label for="location">客戶名稱</label>
            <input type="text" id="location" v-model="formData.lessee_name" placeholder="請輸入停車場地址"
              class="font-control" />
          </div>
          <!-- 聯絡人 -->
          <div class="form-group">
            <label for="name">聯絡人</label>
            <input type="text" id="name" v-model="formData.contact_person" placeholder="請輸入您的姓名" class="font-control" />
          </div>
          <!-- 聯絡電話 -->
          <div class="form-group">
            <label for="phone">聯絡電話</label>
            <input type="tel" id="phone" v-model="formData.contact_phone" placeholder="請輸入您的聯絡電話"
              class="font-control" />
          </div>
          <!-- 方便聯絡時間 -->
          <div class="form-group">
            <label for="email">方便聯絡時間</label>
            <input type="email" id="email" v-model="formData.preferred_contact_time" placeholder="請輸入您方便聯絡的時間"
              class="font-control" />
          </div>
          <div class="form-group">
            <label for="message">其他説明</label>
            <input type="text" id="message" v-model="formData.additional_notes" rows="4" placeholder="請輸入其他備註事項"
              class="font-control" />
          </div>
        </div>
        <!-- 其他説明 -->

      </div>

      <!-- 圖形驗證 -->
      <div class="form-card">
        <div class="form-group">
          <label for="verificationCode">圖形驗證</label>
          <div class="two-columns">
            <input type="text" id="verificationCode" v-model.trim="verificationCode" placeholder="請輸入 4 碼數字"
              inputmode="numeric" pattern="[0-9]*" maxlength="4" autocomplete="off"
              class="font-control" />
            <!-- <div class="captcha-container">
                <canvas ref="captchaCanvas" width="150" height="50"></canvas>
                <button type="button" @click="generateCaptcha">刷新驗證碼</button>
              </div> -->
            <CaptchaComponent ref="captcha" :length="4" :digits-only="true" @update-captcha-code="updateCaptchaCode" />

          </div>
        </div>
      </div>

      <!-- 提交按鈕 -->
      <!-- <div class="form-card"> -->
      <button type="button" class="form-submit-btn" @click="submitForm">確認無誤送出</button>
      <!-- </div> -->
      <!-- </form> -->

    </div>

    <!-- 成功消息 -->

    <SuccessScreen v-if="isSubmissionSuccess" />
    <!-- <SuccessScreen /> -->

  </div>
</template>

<script>
import CaptchaComponent from "@/components/CaptchaComponent";

import PullDAO from "@/services/PullDAO";
import SuccessScreen from "./SuccessScreen.vue";

export default {
  name: "ParkingManagementForm",
  components: {
    CaptchaComponent,
    SuccessScreen,
  },
  data() {
    return {
      formData: {
        parking_type: "平面空地",
        capacity: "50個以下",
        parking_status: "自行經營",
        facilities: [],
        contract_period: "短期六~十二個月內",
        lessee_type: "個人",
        alliance: "同業聯盟",
        location: "",
        lessee_name: "王大明",
        contact_person: "",
        contact_phone: "",
        preferred_contact_time: "",
        additional_notes: "",
      },
      verificationCode: "",
      captchaCode: "",

      isSubmissionSuccess: false,
      equipmentOptions: [
        { value: "無設備", label: "無設備" },
        { value: "管理亭或管理室", label: "管理亭或管理室" },
        { value: "自動按鈕取票機", label: "自動按鈕取票機" },
        { value: "自動繳費機", label: "自動繳費機" },
        { value: "電腦計費系統", label: "電腦計費系統" },
        { value: "監視器", label: "監視器" },
        { value: "驗票機與讀卡機", label: "驗票機 與 讀卡機" },
      ],
    };
  },
  mounted() {
    // this.generateCaptcha();
  },
  methods: {

    async submitForm() {

      console.log(this.formData);

      if (this.verificationCode !== this.captchaCode) {
        alert("驗證碼錯誤，請重新輸入。");
        // 原本呼叫不存在的 this.generateCaptcha() 會丟例外；改成刷新子元件的驗證碼
        this.verificationCode = "";
        if (this.$refs.captcha) this.$refs.captcha.generateCaptcha();
        return;
      }
      try {
        const pullDAO = new PullDAO();
        const response = await pullDAO.addCollaboration({ ...this.formData });
        this.isSubmissionSuccess = response.success;
      } catch {
        alert("提交失敗，請稍後再試！");
      }
    },
    toggleEquipment(value) {
      const index = this.formData.facilities.indexOf(value);
      if (index === -1) this.formData.facilities.push(value);
      else this.formData.facilities.splice(index, 1);
    },
    updateCaptchaCode(newCode) {
      this.captchaCode = newCode;
    },


    goToHomePage() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
/* @import "@/css/global.css"; */
@import "@/css/form.css";
/* 兩列佈局 */
  /* 主標題樣式 */
  .page-title {
    margin-bottom: 0px;
  }
  


</style>
